<template>
    <v-table    ref="table"
                :fields="fields"
                with-items
                :settings="false"
                :items="employees"></v-table>
</template>

<script>
export default {
    props:{
        employees:{
            type:Array,
            default:()=>([])
        }
    },
    data(){
        return {
            fields:[
                {key:'FullName',name:'Personel'},
                {key:'IdentityNumber',name:'Kimlik Numarası'},
                {key:'SGKJobNoticeInfo',name:'SGK İşe Giriş Bilgisi'},
                {key:'AmountStr',name:'Tutar'},
            ]
        }
    }
}
</script>